import { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { DefaultLayout } from "../../../../layouts/Default";
import { Main } from "../../../../themes/Default/components/Main";
import { Title } from "../../../../themes/Default/components/Title";
import { TopNavigation } from "../../../../themes/Default/components/TopNavigation";
import { Breadcrumps } from "../../../../themes/Default/components/Breadcrumps";
import { Link } from "../../../../themes/Default/components/Breadcrumps/components/Link";
import { Button, ButtonBack } from "../../../../themes/Default/components/TopNavigation/components/Button";
import { List } from "../../../../themes/Default/components/List";
import { Header as ListHeader } from "../../../../themes/Default/components/List/components/Header";
import { Body as ListBody } from "../../../../themes/Default/components/List/components/Body";
import { TableHead } from "../../../../themes/Default/components/List/components/Body/components/TableHead";
import { TableBody } from "../../../../themes/Default/components/List/components/Body/components/TableBody";
import { TableRow } from "../../../../themes/Default/components/List/components/Body/components/TableHead/components/TableRow";
import { TableHeadCell } from "../../../../themes/Default/components/List/components/Body/components/TableHead/components/TableRow/components/TableHeadCell";
import { TableDataCell } from "../../../../themes/Default/components/List/components/Body/components/TableBody/components/TableDataCell";
import { Title as ListTitle } from "../../../../themes/Default/components/List/components/Header/components/Title";
import { Checkbox } from "../../../../themes/Default/components/Form/components/Checkbox";
import { studentsManagement } from "../../../../hooks/api/StudentsManagement";
import { Tabs } from "../../../../themes/Default/components/Tabs";
import { useTranslation } from "react-i18next";
import { Color } from "../../../../themes/Default/components/List/components/Body/components/TableBody/components/TableDataCell/components/Color";
import { Slide, toast, ToastContainer } from "react-toastify";
import Toaster from "../../../../themes/Default/components/Toaster/Toaster";

const Notes = () => {
    const { t } = useTranslation("common");
    const { studentId } = useParams();
    const navigate = useNavigate();
    const [disableDelete, setDisableDelete] = useState(true);
    const [selectedNotes, setSelectedNotes] = useState([]);
    const [notes, setNotes] = useState();
    const [student, setStudent] = useState();
    const { useViewStudentsMutation, useNotesListMutation, useDeleteNoteMutation } = studentsManagement;
    const [viewStudent] = useViewStudentsMutation();
    const [notesList, { isLoading }] = useNotesListMutation();
    const [deleteNote] = useDeleteNoteMutation();

    const tabs = [
        { title: t("details"), onClick: () => gotoDetailsTab(studentId) },
        // { title: t("students.tests"), onClick: () => gotoTestsTab(studentId) },
        { title: t("students.contract"), onClick: () => gotoContractsTab(studentId) },
        { title: t("calls.title"), onClick: () => gotoCallsTab(studentId) },
        { title: t("groups.title"), onClick: () => gotoGroupsTab(studentId) },
        { title: t("students.certificates"), onClick: () => gotoCertificatesTab(studentId) },
        { title: t("documents"), onClick: () => gotoDocumentsTab(studentId) },
        { title: t("notes"), isActive: true },
    ];

    const gotoCallsTab = (studentId) => {
        navigate("/students/" + studentId + "/calls");
    };

    const gotoContractsTab = (studentId) => {
        navigate("/students/" + studentId + "/contracts");
    };

    const gotoCertificatesTab = (studentId) => {
        navigate("/students/" + studentId + "/certificates");
    };

    const gotoDetailsTab = (studentId) => {
        navigate("/students/edit/" + studentId);
    };

    const gotoTestsTab = (studentId) => {
        navigate("/students/" + studentId + "/tests");
    };

    const gotoGroupsTab = (studentId) => {
        navigate("/students/" + studentId + "/groups");
    };

    const gotoDocumentsTab = (studentId) => {
        navigate("/students/" + studentId + "/documents");
    };

    const gotoNew = () => {
        navigate(`/students/${studentId}/notes/add`);
    };

    const onSelectionChange = (id) => {
        setSelectedNotes((prevSelected) => {
            if (prevSelected.includes(id)) {
                return prevSelected.filter((recordId) => recordId !== id);
            } else {
                return [...prevSelected, id];
            }
        });
    };

    const onDelete = () => {
        toast.warn(
            ({ closeToast }) => (
                <Toaster
                    closeToast={closeToast}
                    description={t("areYouSure")}
                    optionNo={t("no")}
                    optionYes={t("yes")}
                    onClick={() => {
                        closeToast();
                        for (let i = 0; i < selectedNotes?.length; i++) {
                            const noteId = selectedNotes[i];
                            deleteNote({ studentId, noteId }).then((result) => {
                                notesList(studentId).then((result) => {
                                    const notes = result?.data?.records;
                                    setNotes(notes);
                                });
                                setDisableDelete(true);
                                toast.info(result?.data?.info?.responseMessage);
                            });
                        }
                    }}
                />
            ),
            {
                autoClose: false,
                progress: false,
                closeButton: false,
            },
        );
    };

    useEffect(() => {
        if (selectedNotes.length > 0) {
            setDisableDelete(false);
        } else {
            setDisableDelete(true);
        }
    }, [selectedNotes]);

    useEffect(() => {
        notesList(studentId).then((result) => {
            const notes = result?.data?.records;
            setNotes(notes);
        });
    }, [notesList]);

    useEffect(() => {
        viewStudent(studentId).then((result) => {
            setStudent(result?.data);
        });
    }, []);

    return (
        <DefaultLayout>
            
            <TopNavigation>
                <ButtonBack to="/students" />
                <Button title={t("students.addNotes")} icon="fa-regular fa-plus" onClick={gotoNew}></Button>
                <Button title={t("delete")} icon="fa-regular fa-trash-can" isDisabled={disableDelete} onClick={onDelete}></Button>
            </TopNavigation>
            <Tabs tabs={tabs} />
            <Main>
                <Title>
                    {student?.firstName} {student?.lastName}
                </Title>
                <Breadcrumps>
                    <Link title={t("students.title")} icon="fa-user-graduate" />
                    <Link title={t("notes")} />
                    <Link title={t("settings.list")} isActive={true} />
                </Breadcrumps>
                {!isLoading && (
                    <>
                        <List>
                            <ListHeader>
                            </ListHeader>
                            <ListBody>
                                <TableHead>
                                    <TableRow>
                                        <TableHeadCell></TableHeadCell>
                                        <TableHeadCell>
                                            <span>{t("test.date")}</span>
                                        </TableHeadCell>
                                        <TableHeadCell>
                                            <span>{t("students.typeName")}</span>
                                        </TableHeadCell>
                                        <TableHeadCell>
                                            <span>{t("students.noteTitle")}</span>
                                        </TableHeadCell>
                                        <TableHeadCell>
                                            <span>{t("students.description")}</span>
                                        </TableHeadCell>
                                        <TableHeadCell></TableHeadCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {notes?.length > 0 &&
                                        notes?.map((note, index) => {
                                            return (
                                                <TableRow key={note.id}>
                                                    <TableDataCell>
                                                        <Checkbox name="isBlockClass" value={note.id} onChange={() => onSelectionChange(note.id)} />
                                                    </TableDataCell>
                                                    <TableDataCell>{note.date}</TableDataCell>
                                                    <TableDataCell>{note.typeName}</TableDataCell>
                                                    <TableDataCell>{note.title}</TableDataCell>
                                                    <TableDataCell>{note.description}</TableDataCell>
                                                    <TableDataCell></TableDataCell>
                                                </TableRow>
                                            );
                                        })}
                                </TableBody>
                            </ListBody>
                        </List>
                    </>
                )}
            </Main>
        </DefaultLayout>
    );
};

export default Notes;
